import { render } from "./AssistantIcon.vue?vue&type=template&id=1b60ded6&scoped=true"
import script from "./AssistantIcon.vue?vue&type=script&lang=js"
export * from "./AssistantIcon.vue?vue&type=script&lang=js"

import "./AssistantIcon.vue?vue&type=style&index=0&id=1b60ded6&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b60ded6"],['__file',"src/Components/ChatWidget/AssistantAi/icons/AssistantIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b60ded6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b60ded6', __exports__)) {
    api.reload('1b60ded6', __exports__)
  }
  
  module.hot.accept("./AssistantIcon.vue?vue&type=template&id=1b60ded6&scoped=true", () => {
    api.rerender('1b60ded6', render)
  })

}


export default __exports__